import { BorrowFollowSixContainer } from "../../containers/borrowSystem/BorrowFollowSixContainer";

export function BorrowFollowSixPage() {
    return (
        <BorrowFollowSixContainer />
    )
}
